<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">车牌列表</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()"/>
    </div>
    <!-- 返回 结束 -->
   <!-- 车牌列表 开始 -->
       <div class="licese_list">
         <div class="licese_box" v-for="(item,index) in  licenseList " @click="buttonClicked ? '' : taplist(index)" id="licesedIndexChange">
           <div class="licese_box_left">
             <div class="licese_redio">
               <!-- <input type="radio" :checked="item.checked" /> -->
               <img class="checkimg" :src="item.checked?'/static/newprojecticon/checked.png' : '/static/newprojecticon/nocheck.png'" />
             </div>
             <div class="licese_mesg">
               <div class="licese_me">{{ item.car_no  }}</div>
               <div v-if=" item.brand || item.vehicle_type " class="licese_num">{{ item.brand }} {{
                                       item.vehicle_type }}
                         </div>
               <!-- <div class="licese_num">{{ item.card_no }}</div> -->
             </div>
           </div>

           <img class="licese_shanchu" src="/static/newprojecticon/del.png" @click.stop="tap('liceseIndexDelete',index)" />
         </div>
       </div>
       <!-- 车牌列表 结束 -->
       <!-- 新增车牌 开始 -->
       <div class="page_button liceselist_button"  hover-class="commonBg" @click="tap('toLicenseAdd')" >
         <div class="page_zhifu">新增车牌</div>
       </div>
       <!-- 新增车牌 结束 -->
	   <!-- 暂无信息  开始 -->
	   <div class="page_none lice_none" v-if="licenseList.length==0">
	     <img src="/static/newprojecticon/zanwujilu.png" class="page_none_icon" />
	   </div>
	   <!-- 暂无信息  结束 -->
  </div>
</template>

<script>
  // import swal from 'sweetalert'
  import httper from '../../api/http'
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        id: "",
        licenseList: [], // 接口获取车信息列表,默认为空
        licenseIndex: 0, // 车信息指针,默认为0
        buttonClicked: false, // 防止用户重复点击,默认为false
        store_id: "", //上页面传来的店铺id
        package_id: "" //上页面传来的卡券id
      }
    },
    created() {
      // this.request('getOilCardList')
      (this.id = this.$route.query.id ? Number(this.$route.query.id) : ""),
      console.log("id", this.$route.query.id);
      console.log("store_id", this.$route.query.store_id);
      console.log("package_id", this.$route.query.package_id);
      if (this.$route.query.store_id) {
        this.store_id = this.$route.query.store_id
      }
      if (this.$route.query.package_id) {
        this.package_id = this.$route.query.package_id
      } else {
        this.package_id = ""
      }
    },
    mounted() {
      this.request('getLicenseList')
    },
    methods: {
      pageReturn(){
        this.$router.go(-1)
      },
      pageToIndex(){
        this.$router.push({
          path:"/"
        })
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      // 跳转到编辑车信息页
      toLicenseEdit(index) {
        this.$router.push({
          path: '/licenseEdit',
          query: {
            index: index
            // id:that.licenseList[Number(index)].id, // 上一页获取车信息id,默认为空
            // car_no: this.licenseList[index].car_no, // 车牌号码,默认为空
            // brand: this.licenseList[index].brand, // 品牌,默认为空
            // vehicle_type: this.licenseList[index].vehicle_type, // 车型,默认为空
          }
        })
      },
      tap(e, params = '') {
        let that = this
        switch (e) {
          //跳转添加车信息页
          case 'toLicenseAdd':
            this.$router.push({
              path: '/licenseEdit'
            })
            break
          case 'liceseIndexDelete':
            Dialog.confirm({
                title: '提示',
                message: '确认删除?',
              })
              .then(() => {
                let requestData = {
                  id: that.licenseList[Number(params)].id,
                  index: Number(params)
                }
                this.request('delCar', requestData)
                this.request("getLicenseList")
              })
              .catch(() => {
                return false;
              });
            // this.$swal({
            //     title: '提示',
            //     text: "确认删除？",
            //     buttons: ['取消', '确认'],
            // }).then((confirm) => {
            //     if (confirm) {
            //         console.log("confirm", confirm)
            //         console.log("id", that.licenseList[Number(params)].id)
            //         console.log("index", Number(params))
            //         let requestData = {
            //             id: that.licenseList[Number(params)].id,
            //             index: Number(params)
            //         }
            //         this.request('delCar', requestData)
            //         this.request("getLicenseList")
            //     } else {
            //         return false;
            //     }
            // })
            // this.$messagebox.confirm('', {
            //   title: "提示",
            //   message: "确认删除?",
            //   confirmButtonText: '确认',
            //   cancelButtonText: '取消'
            // }).then(action => {
            //   if (action == 'confirm') {
            //     let requestData = {
            //       id: that.licenseList[Number(params)].id,
            //       index: Number(params)
            //     }
            //     this.request('delCar', requestData)
            //     this.request("getLicenseList")
            //   }
            // }).catch(error => {
            //   if (error == 'cancel') {
            //     return false;
            //   }
            // })
            break
        }
      },
      taplist(e) {
        let that = this
        var licenseList = this.licenseList
        if (this.buttonClicked) return
        that.buttonClickedFun(1000)
        licenseList.map((item, index) => item.checked = index === e)
        that.licenseIndex = Number(e)
        console.log("Number(e)", Number(e))
        that.licenseList = licenseList
        var licenseItem = that.licenseList[e]
        console.log("that.licenseList[Number(e)]", licenseItem)
        // console.log("licenseItem",licenseItem)
        //        if(licenseItem){
        //          sessionStorage.setItem("licenseItem", JSON.stringify(licenseItem))
        //          console.log("licenseItem",sessionStorage.getItem("licenseItem"))
        //          // return
        //          this.$router.back()
        //        }
        that.$router.push({
          path: '/reserveDesc',
          query: {
            licenseItem: licenseItem,
            id: that.id,
            store_id: that.store_id,
            package_id: that.package_id
          }
        })
        // that.$router.push({
        //   name: 'reserveDesc',
        //   // query: {
        //   //   licenseItem: licenseItem,
        //   //   id:that.id
        //   // }
        // })
      },
      request(type = '', requestData = {}) {
        let that = this
        let data = {}
        switch (type) {
          // 获取车信息列表
          case 'getLicenseList':
            httper.get('user/car-list', requestData, res => {
              console.log('车信息列表', res.data)
              res.data.map((item, index) => item.checked = index === that.licenseIndex)
              that.licenseList = res.data
            })
            break
            // 删除车信息(待测试
          case 'delCar':
            httper.get('user/del-car', requestData, res => {
              console.log('删除车信息', res)
              if (res.code === 0) {
                window.location.reload()
              } else {
                this.$toast({
                  message: '删除失败',
                })
              }
            }, true)
            break
        }
      }
      // // 点击触发
      // tap (e) {
      //   let currentTarget = e.currentTarget
      //   let dataset = currentTarget.dataset
      //   let that = this
      //   let data = {}
      //   let requestData = {}
      //   switch (currentTarget.id) {
      //     // 改变车信息指针,并返回上一页
      //     case 'licenseIndexChange':
      //       if (this.data.buttonClicked) return
      //       common.buttonClicked.call(this, 1500)
      //       this.data.licenseList.map((item, index2) => item.checked = index2 === Number(dataset.index))
      //       data.licenseList = this.data.licenseList
      //       this.setData(data)
      //       wx.showToast({
      //         title: '选择成功',
      //         duration: 1000,
      //         success () {
      //           console.log(getCurrentPages()[getCurrentPages().length - 2])
      //           data.bookingItem = getCurrentPages()[getCurrentPages().length - 2].data.bookingItem
      //           data.bookingItem.licenseItem = that.data.licenseList[Number(dataset.index)]
      //           getCurrentPages()[getCurrentPages().length - 2].setData(data)
      //           setTimeout(() => {
      //             wx.navigateBack()
      //           }, 1000)
      //         }
      //       })
      //       break

    }
  }
</script>

<style scoped>
.licese_list {
    width: 90%;
    padding: 20px;
  }

  .licese_box {
    width: 100%;
    height: 76px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 7px 2px rgba(187, 187, 187, 0.3);
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .licese_box_left {
    display: flex;
    align-items: center;
  }

  .licese_redio {
    margin-right: 10px;
    width: 14px;
    height: 14px;
  }

  .licese_mesg {
    display: flex;
    flex-direction: column;
  }

  .licese_me {
    font-size: 14px;
    font-weight: 400;
    color: rgba(54, 54, 54, 1);

  }

  .licese_num {
    font-size: 10px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }

  .licese_shanchu {
    width: 19px;
    height: 19px;
  }
  .liceselist_button{
    position: fixed;
    bottom: 50px;
  }
  .checkimg{
    width: 14px;
    height: 14px;
  }
  .lice_none{
	  left: 43%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/liceseList.vue